import { createContext, useContext } from 'react';
export var SolarMenuContext = createContext(null);
export var useSolarMenuContext = function () {
    var context = useContext(SolarMenuContext);
    if (context === null) {
        throw new Error('useSolarMenuContext must be used inside a SolarMenuContextProvider');
    }
    return context;
};
export var SolarMenuContextProvider = SolarMenuContext.Provider;
